module.exports = __webpack_public_path__ + "img/logo.d8d3cb5d.png";